import { Navigate, createFileRoute } from '@tanstack/react-router';

/** /settings opens the first tab. */
export const Route = createFileRoute('/settings/')({
  component: () => <Navigate to="/settings/users" replace />,
});
